import VaultHomePage from '@components/vault/VaultHomePage'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'account',
        'close-account',
        'common',
        'notifications',
        'onboarding',
        'onboarding-tours',
        'profile',
        'settings',
        'swap',
        'trade',
        'tv-chart',
        'errors',
        'pools',
      ])),
    },
  }
}

const Index = () => {
  return <VaultHomePage />
}

export default Index
